import axios from "axios";
import { getViewTenant } from "@/lib/viewTenant";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function makeApi(getToken) {
  const instance = axios.create({ baseURL: API });
  instance.interceptors.request.use(async (config) => {
    try {
      const token = await getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch { /* ignore */ }
    const view = getViewTenant();
    if (view) config.headers["X-View-Tenant"] = view.id;
    return config;
  });
  return instance;
}

export async function authedUrl(path, getToken) {
  const token = await getToken();
  const view = getViewTenant();
  return `${API}${path}${path.includes("?") ? "&" : "?"}auth=${encodeURIComponent(token || "")}${view ? `&view_tenant=${view.id}` : ""}`;
}
